module.exports = __webpack_public_path__ + "media/debris-4.e5009bd2.webm";